const KEY = "smrt_mid";
const VALID = /^[A-Za-z0-9_-]{1,64}$/; // must match the backend exactly

function clean(value) {
  if (typeof value !== "string") return null;
  const v = value.trim();
  return VALID.test(v) ? v : null;
}

function fromCookie() {
  if (typeof document === "undefined") return null;
  const hit = document.cookie
    .split("; ")
    .find((c) => c.trim().startsWith(`${KEY}=`));
  return hit ? clean(decodeURIComponent(hit.trim().slice(KEY.length + 1))) : null;
}

function fromUrl() {
  if (typeof window === "undefined" || !window.location) return null;
  return clean(new URLSearchParams(window.location.search).get("mid"));
}

export function getMid() {
  if (typeof window === "undefined") return null; // SSR guard
  try {
    const fromQuery = fromUrl();
    if (fromQuery) {
      try {
        localStorage.setItem(KEY, fromQuery);
      } catch (err) {
        // Ignore storage availability or quota errors
      }
      return fromQuery;
    }
    return clean(localStorage.getItem(KEY)) ?? fromCookie();
  } catch {
    return null; // Safari private mode etc. — never throw
  }
}
